// import React from 'react';
import { Header } from '../components/ui/header-2';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Features } from '../components/landing/Features';
import { HowItWorks } from '../components/landing/HowItWorks';
// import { ProductPreview } from '../components/landing/ProductPreview';
import { RevenueImpact } from '../components/landing/RevenueImpact';
import { Audience } from '../components/landing/Audience';
import { TrustSection } from '../components/landing/TrustSection';
// import { Integrations } from '../components/landing/Integrations';
// import { Pricing } from '../components/landing/Pricing';
import { CtaSection } from '../components/landing/CtaSection';
import { Footer } from '../components/landing/Footer';
import { ExploreFeature } from '../components/landing/ExploreFeature';

export const LandingApp = () => (
    <>
        <Header />
        <main style={{ overflowX: 'hidden' }}>
            <Hero />
            <Problem />
            <Features />
            <HowItWorks />
            <ExploreFeature />
            {/* <ProductPreview /> */}
            <RevenueImpact />
            <Audience />
            <TrustSection />
            {/* <Integrations /> */}
            {/* <Pricing /> */}
            <CtaSection />
        </main>
        <Footer />
    </>
);
